import {
  Theme as MatTheme,
  adaptV4Theme,
  stepIconClasses,
  stepLabelClasses,
  tabClasses,
  filledInputClasses,
  formLabelClasses,
  buttonBaseClasses,
  inputLabelClasses
} from '@mui/material';
// TODO: Figure out themeAugmentation with Typescript happy
// import type {} from '@mui/lab/themeAugmentation';
import { createTheme, DeprecatedThemeOptions } from '@mui/material/styles';
import { Shadows } from '@mui/material/styles/shadows';
import makeStyles from '@mui/styles/makeStyles';
import { customArcherColors } from './customArcherColors';
import { treeItemClasses } from '@mui/lab';

const archerConstants = {
  archerHover: 'rgba(23, 109, 194, 0.07)',
  archerActive: 'rgba(23, 109, 194, 0.15)',
  archerPrimaryButtonHover: '#337FC9',
  archerPrimaryButtonActive: '#5192D1',
  archerButtonHover: '#EFF5FB',
  archerButtonActive: '#DCE9F6',
  archerInputFocus: 'rgba(33, 33, 33, 0.06)',
  archerPrimary: '#176DC2',
  buttonPadding: '0.4rem 0.75rem',
  archerTextPrimary: '#212121',
  archerTextSecondary: '#616161',
  archerTextHint: 'rgba(0, 0, 0, 0.38)',
  archerError: '#c62828',
  archerDisabled: '#9e9e9e',
  archerContrastRatioSafe: '#0D47A1',
  archerBackgroundPaper: '#FFFFFF',
  shadows: [
    'none',
    '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
    '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
    '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
    '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)'
  ] as Shadows
};

export type Theme = MatTheme;

const theme: Theme = createTheme(
  adaptV4Theme({
    typography: {
      fontFamily: ['Lato', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
      fontSize: 16,
      fontWeightLight: 300,
      fontWeightMedium: 500,
      fontWeightRegular: 500,
      fontWeightBold: 700,
      body1: {
        fontSize: '0.875rem',
        fontWeight: 500
      },
      body2: {
        fontSize: '0.75rem',
        fontWeight: 500
      },
      button: {
        fontSize: '0.875rem',
        fontWeight: 700,
        textTransform: 'uppercase'
      },
      caption: {
        fontSize: '0.625rem',
        fontWeight: 500
      },
      h1: {
        fontSize: '2.25rem',
        fontWeight: 700
      },
      h2: {
        fontSize: '1.75rem',
        fontWeight: 700
      },
      h3: {
        fontSize: '1.25rem',
        fontWeight: 700
      },
      h4: {
        fontSize: '1rem',
        fontWeight: 700
      },
      h5: {
        fontSize: '0.875rem',
        fontWeight: 700
      },
      h6: {
        fontSize: '0.75rem',
        fontWeight: 700
      },
      overline: {
        fontSize: '0.75rem',
        fontWeight: 500,

        textTransform: 'uppercase'
      },
      subtitle1: {
        fontSize: '1.125rem',
        fontWeight: 500
      },
      subtitle2: {
        fontSize: '1rem',
        fontWeight: 500
      }
    },
    spacing: 8,
    shadows: archerConstants.shadows,
    shape: {
      borderRadius: 3
    },
    transitions: {
      easing: {
        easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
        easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
        easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
        sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
      },
      duration: {
        shortest: 150,
        shorter: 200,
        short: 250,
        standard: 300,
        complex: 375,
        enteringScreen: 225,
        leavingScreen: 195
      }
    },
    palette: {
      primary: {
        main: archerConstants.archerPrimary
      },
      secondary: {
        main: archerConstants.archerPrimary
      },
      error: {
        main: archerConstants.archerError
      },
      text: {
        primary: archerConstants.archerTextPrimary,
        secondary: archerConstants.archerTextSecondary,
        disabled: archerConstants.archerDisabled,
        hint: archerConstants.archerTextHint
      },
      action: {
        active: archerConstants.archerActive,
        hover: archerConstants.archerHover,
        hoverOpacity: 0.07,
        selected: archerConstants.archerActive,
        disabled: archerConstants.archerDisabled
      },
      background: {
        paper: archerConstants.archerBackgroundPaper,
        default: '#f7f7f7'
      },
      grey: {
        50: '#F7F7F7',
        100: '#EEEEEE',
        300: '#E0E0E0',
        600: '#9E9E9E',
        800: '#616161',
        900: '#212121'
      }
    },
    direction: 'ltr',
    overrides: {
      MuiListItem: {
        root: {
          '&:focus': {
            backgroundColor: archerConstants.archerHover
          },
          '&:active': {
            backgroundColor: archerConstants.archerActive
          }
        }
      },
      MuiChip: {
        root: {
          fontSize: '0.75rem',
          backgroundColor: '#fff',
          border: '1px solid #E0E0E0',
          fontWeight: 700,
          marginRight: '0.5rem',
          height: 'auto'
        },
        label: {
          padding: '0.219rem',
          paddingLeft: '0.45rem',
          paddingRight: '0.45rem',
          textTransform: 'uppercase'
        },
        clickable: {
          '&:hover': {
            backgroundColor: 'rgba(33, 33, 33, 0.07)'
          },
          '&:focus, &:active': {
            backgroundColor: 'rgba(33, 33, 33, 0.15)'
          },
          '&:active': {
            boxShadow: archerConstants.shadows[0]
          }
        },
        deletable: {
          '&:focus': {
            backgroundColor: 'rgb(206, 206, 206)'
          }
        },
        deleteIcon: {
          color: archerConstants.archerTextSecondary,
          width: '1rem',
          height: '1rem',
          margin: '0 0.3125rem 0 0',
          '&:hover': {
            color: archerConstants.archerTextSecondary
          }
        }
      },
      MuiStepButton: {
        touchRipple: {
          focusVisible: {
            onFocusVisible: true
          },
          color: archerConstants.archerActive
        }
      },
      MuiTouchRipple: {
        child: {
          backgroundColor: archerConstants.archerActive
        },
        childPulsate: {
          backgroundColor: archerConstants.archerActive
        },
        childLeaving: {
          backgroundColor: archerConstants.archerActive
        }
      },
      MuiCheckbox: {
        root: {
          color: archerConstants.archerPrimary,
          padding: '0.5rem'
        }
      },
      MuiRadio: {
        root: {
          padding: '0.5rem',
          color: archerConstants.archerPrimary
        }
      },
      MuiIconButton: {
        root: {
          lineHeight: 'normal',
          padding: '0.5rem',
          '&:hover': {
            backgroundColor: archerConstants.archerHover
          },
          '&:focus, &:active': {
            backgroundColor: archerConstants.archerActive
          },
          '&.focusActive': {
            backgroundColor: archerConstants.archerActive
          }
        }
      },
      MuiButton: {
        root: {
          disableRipple: true,
          lineHeight: 'normal',
          padding: archerConstants.buttonPadding,
          margin: '0.5rem',
          minHeight: '1.875rem',
          boxShadow: archerConstants.shadows[0]
        },
        containedPrimary: {
          boxShadow: archerConstants.shadows[0],
          '&:hover': {
            backgroundColor: archerConstants.archerPrimaryButtonHover,
            boxShadow: archerConstants.shadows[0]
          },
          '&:focus, &:active': {
            backgroundColor: archerConstants.archerPrimaryButtonActive,
            boxShadow: archerConstants.shadows[0]
          },
          '&.Mui-disabled': {
            color: archerConstants.archerBackgroundPaper
          }
        },
        text: {
          color: archerConstants.archerPrimary,
          backgroundColor: archerConstants.archerBackgroundPaper,
          fontWeight: 500,
          padding: archerConstants.buttonPadding,
          '&:hover': {
            color: archerConstants.archerContrastRatioSafe,
            backgroundColor: archerConstants.archerButtonHover
          },
          '&:focus, &:active': {
            color: archerConstants.archerContrastRatioSafe,
            backgroundColor: archerConstants.archerButtonActive
          }
        },
        outlinedSecondary: {
          color: archerConstants.archerPrimary,
          backgroundColor: archerConstants.archerBackgroundPaper,
          border: `1px solid ${archerConstants.archerPrimary}`,
          fontWeight: 500,
          padding: '0.32rem 0.75rem',
          '&:hover': {
            color: archerConstants.archerContrastRatioSafe,
            backgroundColor: archerConstants.archerButtonHover,
            border: `1px solid ${archerConstants.archerContrastRatioSafe}`
          },
          '&:focus, &:active': {
            color: archerConstants.archerContrastRatioSafe,
            backgroundColor: archerConstants.archerButtonActive,
            border: `1px solid ${archerConstants.archerContrastRatioSafe}`
          }
        }
      },
      MuiAccordionDetails: {
        root: {
          padding: '1rem 1.5rem'
        }
      },

      MuiLink: {
        root: {
          '&:focus': {
            outline: '#4D90FE solid 0.0625rem'
          }
        }
      },
      MuiFab: {
        root: {
          color: archerConstants.archerPrimary,
          fontWeight: 700,
          fontSize: '1rem',
          height: '44px',
          width: '44px',
          boxShadow: '0px 0px 6px 2px rgba(33,33,33,0.65)', // custom shadow for FABs.
          backgroundColor: archerConstants.archerBackgroundPaper
        },
        extended: {
          color: archerConstants.archerPrimary,
          borderRadius: '44px',
          width: 'auto',
          height: '44px',
          '&:focus, &:active': {
            boxShadow: '0px 0px 3px 1px rgba(33,33,33,0.65)'
          }
        }
      },
      MuiFormLabel: {
        root: {
          '&.Checkbox-FormControl-Label': {
            color: `${archerConstants.archerTextSecondary} !important`,
            fontWeight: '500 !important' // Overrides the default focus application for formLabels applied to checks and radios
          },
          fontSize: '0.75rem',
          fontWeight: 500,
          [`&.${formLabelClasses['focused']}`]: {
            color: archerConstants.archerPrimary,
            fontWeight: 700
          },
          [`&.${formLabelClasses['error']}`]: {
            fontWeight: 700
          },
          overflow: 'visible !important'
        },
        asterisk: {
          color: customArcherColors.alertColors.error,
          position: 'absolute',
          left: '-0.5rem',
          top: 0
        }
      },
      MuiFormHelperText: {
        root: {
          fontSize: '0.625rem', // caption
          fontWeight: 500, // caption
          color: archerConstants.archerTextPrimary,
          opacity: 0.7,
          position: 'absolute',
          bottom: '-0.85rem'
        },
        contained: {
          marginLeft: '0.75rem'
        }
      },
      MuiInputLabel: {
        root: {
          fontSize: '0.875rem',
          color: archerConstants.archerTextSecondary,
          transform: 'translate(12px, 17px) scale(1)'
        },
        shrink: {
          transform: 'translate(12px, 7px) scale(0.85)'
        },
        filled: {
          transform: 'translate(12px, 17px) scale(1)',
          [`&.${inputLabelClasses['shrink']}`]: {
            transform: 'translate(12px, 7px) scale(0.85)'
          }
        }
      },
      MuiInputAdornment: {
        root: {
          color: archerConstants.archerTextSecondary,
          fontWeight: 500,
          height: '48px'
        },
        positionStart: {
          marginRight: '0.125rem'
        },
        positionEnd: {
          marginLeft: '0.25rem'
        }
      },
      MuiTextField: {
        root: {
          '&:focused': {
            color: archerConstants.archerPrimary
          }
        }
      },
      MuiInputBase: {
        root: {
          '& input': {
            '&::placeholder': {
              color: archerConstants.archerDisabled
            }
          },
          '&.Input-Select': {
            maxHeight: '3rem'
          }
        },
        input: {
          fontSize: '0.875rem',
          padding: '27px 12px 10px'
        }
      },
      MuiFilledInput: {
        root: {
          backgroundColor: archerConstants.archerInputFocus,
          paddingLeft: '13px',

          '&:hover': {
            backgroundColor: archerConstants.archerInputFocus
          },
          [`&.${filledInputClasses['focused']}`]: {
            backgroundColor: archerConstants.archerInputFocus
          },
          [`&.${filledInputClasses['disabled']}`]: {
            backgroundColor: 'rgba(33,33,33,.02)',
            '&:before': {
              borderBottomStyle: 'dashed'
            },
            '& >svg': {
              color: archerConstants.archerDisabled
            }
          }
        },

        underline: {
          '&:before': {
            borderBottom: '1px solid rgba(33,33,33,0.5)'
          },
          '&:after': {
            borderBottom: 'none'
          },
          [`&.${filledInputClasses['focused']}:after`]: {
            borderBottom: `3px solid ${archerConstants.archerPrimary}`
          },
          [`&.${filledInputClasses['error']}:after`]: {
            borderBottom: `3px solid ${archerConstants.archerError}`
          },
          [`&.${filledInputClasses['disabled']}:after`]: {
            backgroundColor: 'rgba(33,33,33, 0.02)',
            '&:before': {
              borderBottom: '1px dashed rgba(33,33,33,0.28)'
            }
          }
        },
        input: {
          paddingLeft: '0'
        }
      },

      MuiPopover: {
        root: {
          '&[class*="PageSizeSelector-selectMenu"]': {
            position: 'fixed !important'
          }
        }
      },

      MuiSelect: {
        select: {
          maxHeight: '3rem',
          '&:focus': {
            backgroundColor: 'unset'
          }
        },
        icon: {
          color: archerConstants.archerPrimary,
          height: '1.5rem',
          width: '1.5rem',
          top: 'calc(50% - 10px)'
        },
        filled: {
          paddingRight: '35px'
        }
      },
      MuiMenuItem: {
        root: {
          '&:hover': {
            backgroundColor: 'rgba(23,109,194,0.07)'
          }
        }
      },
      MuiSvgIcon: {
        root: {
          fontSize: '1.25rem'
        },
        fontSizeSmall: {
          fontSize: '1rem'
        },
        fontSizeLarge: {
          fontSize: '1.5rem'
        }
      },
      MuiTableHead: {
        root: {
          '& tr:first-child': {
            height: '1.875rem'
          }
        }
      },
      MuiTableCell: {
        root: {
          '& a': {
            textDecoration: 'none'
          }
        },
        body: {
          fontSize: '0.875rem',
          fontWeight: 500
        }
      },
      MuiStepIcon: {
        root: {
          fill: '#E0E0E0',
          [`&.${stepIconClasses['active']}`]: {
            fill: archerConstants.archerPrimary,
            [`& .${stepIconClasses['text']}`]: {
              fill: 'white',
              fontSize: '0.8rem', // 1rem for h4 didn't align the text properly in the middle, thus changing to 0.8
              fontWeight: 700 // h4
            }
          },
          [`&.${stepIconClasses['completed']}`]: {
            fill: archerConstants.archerPrimary
          }
        },
        text: {
          fontSize: '0.8rem', // 1rem for h4 didn't align the text properly in the middle, thus changing to 0.8
          fontWeight: 700, // h4
          fill: '#616161' // textSecondary
        }
      },
      MuiStepLabel: {
        label: {
          [`&.${stepLabelClasses['alternativeLabel']}`]: {
            marginTop: '8px'
          }
        }
      },
      MuiFormGroup: {
        root: {
          '&.radioGroupHorizontal': {
            flexDirection: 'row',
            '& [class*="MuiFormControlLabel-root"]': {
              marginRight: '32px'
            }
          }
        }
      },
      MuiFormControl: {
        marginDense: {
          marginTop: '4px',
          marginBottom: '4px',
          marginLeft: '4px',
          marginRight: '4px'
        },
        marginNormal: {
          marginTop: '8px',
          marginBottom: '8px',
          marginLeft: '8px',
          marginRight: '8px'
        },
        root: {
          '&.FormControl-Select': {
            maxHeight: '3rem'
          }
        }
      },
      MuiButtonBase: {
        root: {
          [`&.${buttonBaseClasses['focusVisible']}`]: {
            backgroundColor: '#FF0000'
          }
        }
      },
      MuiTab: {
        root: {
          flexGrow: 1,
          minHeight: '2rem',
          maxWidth: 'unset',
          height: '2rem',
          fontSize: '.875rem',
          fontWeight: 500,
          backgroundColor: 'transparent',
          [`&.${tabClasses['selected']}`]: {
            '&:focus': {
              backgroundColor: archerConstants.archerActive
            },
            fontWeight: '700',
            borderLeft: '1px solid #9E9E9E',
            borderRight: '1px solid #9E9E9E',
            borderBottom: 0
          }
        },
        textColorPrimary: {
          [`&.${tabClasses['selected']}`]: {
            color: archerConstants.archerContrastRatioSafe
          }
        }
      },
      MuiTabs: {
        root: {
          minHeight: '2rem',
          marginTop: '.5rem',
          overflow: 'visible'
        },
        flexContainer: {
          width: '100%'
        },
        indicator: {
          height: '.19rem'
        }
      },
      MuiTooltip: {
        tooltip: {
          fontSize: '12px'
        }
      },
      MuiTreeItem: {
        content: {
          [`&.${treeItemClasses['selected']}`]: {
            [`&.${treeItemClasses['focused']}`]: {
              backgroundColor: archerConstants.archerHover
            },
            backgroundColor: 'transparent'
          }
        }
      },
      MuiPickersDay: {
        root: {
          fontSize: '12px'
        }
      }
    },

    props: {
      MuiButtonBase: {
        disableRipple: true
      }
    },
    zIndex: {
      mobileStepper: 1000,
      speedDial: 1050,
      appBar: 1100,
      drawer: 1200,
      modal: 1300,
      snackbar: 1400,
      tooltip: 1500
    }
    // TODO: Remove type cast
  } as DeprecatedThemeOptions)
);

/**
 * Re-export makeStyles and Theme so that consumers of @archer/ui-components can apply additional styles
 */
export { theme, makeStyles, archerConstants };
